import React from 'react'

const ShipyardEvaluationOfShipyardPerformance = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <h4>SHIPYARD EVALUATION OF SHIPYARD PERFORMANCE</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="report-index-top">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2 w150">
                                                    <p>Name of Shipyard</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Shipyard</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Ship Owner</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Owner Name"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 w150 pl10 ">
                                                    <p>Build Duration</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Duration"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 w150 ">
                                                    <p>Project </p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Emter Project name"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>No of Ships built</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="No of Ships built"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 w150 pl10 ">
                                                    <p>Date of Report</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Date of Report"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="appraisal-report-table-responsive">
                            <table className="assessment-table" cellSpacing={0}>
                                <tbody>
                                    <tr style={{ height: "28pt" }}>
                                        <td className="hd-s1" colSpan={5}>
                                            <p>EVALUATION CRITERIA</p>
                                        </td>
                                        <td className="hd-s2 w200">
                                            <p>Evaluation Grading (1 to 5)</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">1.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Co-operation with Owner’s Team to meet specified
                                                requirements
                                            </p>
                                            <p className="s2">(a) At drawing/ plan approval stage</p>
                                            <p className="s2">(b) At ship construction stage</p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">2.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Response to Owner’s Additional Work requirements
                                            </p>
                                            <p className="s3">(a) Prompt Response/ Follow up</p>
                                            <p className="s3">
                                                (b) Proactive approach to meet the requirement
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">3.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Quality Policy &amp; Practice</p>
                                            <p className="s3">(a) Documented Quality Policy in place</p>
                                            <p className="s3">
                                                (b) Practicing the Approved Quality Standards
                                            </p>
                                            <p className="s3">(c) Level of QA assurance by Yard Team</p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">4.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">HSE Policy &amp; Practice</p>
                                            <p className="s3">(a) Documented HSE Policy in place</p>
                                            <p className="s3">
                                                (b) Practicing the Approved HSE Standards
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "23pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">5.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Quality of Design Team</p>
                                            <p className="s3">
                                                (a) Strength of Qualified Technical Design Teams
                                            </p>
                                            <p className="s3">
                                                (b) Proactive approach to suggestion on modifications
                                            </p>
                                            <p className="s3">(c) Quality of Design Documentations</p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "26pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">6.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">On-Time Delivery</p>
                                            <p className="s3">
                                                (a) Adhere to original Delivery Commitments
                                            </p>
                                            <p className="s3">(b) Efforts to contain Slippages, if any</p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">7.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">After Sales Service</p>
                                            <p className="s3">(a) Speedy Response to Warranty Claims</p>
                                            <p className="s3">
                                                (b) Follow up for positive resolution of claims
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">8.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Overall Performance of the yard</p>
                                            <p className="s3">(a) Comparable with competitor yards</p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s2" colSpan={5}>
                                            <p className="s1 pl10 red">Grade</p>
                                        </td>
                                        <td className="td-s3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="gard-table">
                                <tbody>
                                    <tr className="gard-row">
                                        <td>
                                            <p className="s4">Grade:</p>
                                        </td>
                                        <td>
                                            <p className="s4">1. Poor</p>
                                        </td>
                                        <td>
                                            <p className="s4">2. Average</p>
                                        </td>
                                        <td>
                                            <p className="s4">3. Good</p>
                                        </td>
                                        <td>
                                            <p className="s4">4. Very Good</p>
                                        </td>
                                        <td>
                                            <p className="s4">5. Exceptionally Good</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="mt-5">
                                <tbody>
                                    <tr className="sig-tr2-box1">
                                        <td className="input-td">
                                            <p className="s2 text-right">Site Manager</p>
                                        </td>
                                        <td className="w50" />
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="sig-tr2-box1">
                                        <td className="input-td">
                                            <p className="s2 text-right">
                                                (Name &amp; Signature of Person Evaluated){" "}
                                            </p>
                                        </td>
                                        <td className="w50" />
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="row mt-3">
                                <div className="col-lg-12 text-left ">
                                    <a
                                        href="ship-inspection-progress-list.php"
                                        className="btn btn-success"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                    >
                                        Submit
                                    </a>
                                    <button
                                        type="reset"
                                        className="btn btn-danger ms-3"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ShipyardEvaluationOfShipyardPerformance